import styled from 'styled-components';

export const FakeButton = styled.label`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.km2};
  white-space: nowrap;
  border-radius: ${({ theme }) => theme.border.radius.large};
  padding: ${({ theme }) => `${theme.spacing.km0} ${theme.spacing.km4}`};
  cursor: pointer;
  font-size: ${({ theme }) => theme.font.size.m3};
  font-weight: ${({ theme }) => theme.font.weight.bold};
  border: ${({ theme }) => theme.color.border.neutral.default};

  color: ${({ theme }) => theme.color.text.neutral.strong};
  background: transparent;
  border: ${({ theme }) =>
    `${theme.border.width.thinner} ${theme.border.style.solid} ${theme.color.border.neutral.strong}`};

  width: 100%;

  :hover {
    background-color: ${({ theme }) => theme.color.background.neutral.weak};
  }
`;
